export const SET_BACKGROUND_ANIM: String = 'SET_BACKGROUND_ANIM';
export const RESET_BACKGROUND_ANIM: String = 'RESET_BACKGROUND_ANIM';

export interface BackgroundDataAnim {
    value: string;
}

export interface BackgroundAnimAction {
    type: typeof SET_BACKGROUND_ANIM;
    payload: BackgroundDataAnim;
}

export const setBackgroundAnimAction = (payload: BackgroundDataAnim): BackgroundAnimAction => {
    return {
        type: SET_BACKGROUND_ANIM,
        payload,
    };
};

export const ResetBackgroundAction = () => {
    return {
        type: RESET_BACKGROUND_ANIM,
    };
};
